import { render, staticRenderFns } from "./kendo-slider.vue?vue&type=template&id=3cbe73dc&scoped=true"
import script from "./kendo-slider.vue?vue&type=script&lang=js"
export * from "./kendo-slider.vue?vue&type=script&lang=js"
import style0 from "./kendo-slider.vue?vue&type=style&index=0&id=3cbe73dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbe73dc",
  null
  
)

export default component.exports